import { createFileRoute } from '@tanstack/react-router';
import StubPage from '@/pages/StubPage.jsx';

function SourcesRoute() {
  return <StubPage name="sources" label="Archetypes" />;
}

export const Route = createFileRoute('/sources')({ component: SourcesRoute });
